var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-particles',{attrs:{"color":"#dedede","particleOpacity":0.7,"particlesNumber":80,"shapeType":"circle","particleSize":4,"linesColor":"#dedede","linesWidth":1,"lineLinked":true,"lineOpacity":0.4,"linesDistance":150,"moveSpeed":5,"hoverEffect":true,"hoverMode":"grab","clickEffect":true,"clickMode":"push"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d79bb56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = null
// module chunks = 